<template>
  <div class="link-views no-bg">
    <div class="select-div">
      <div class="mr">
        <span>选择班级：</span>
        <i-select v-model="pageData.ClassId" style="width:200px">
          <i-option
            v-for="item in ClassArr"
            :value="item.ClassId"
            :key="item.ClassId"
          >{{ item.ClassName }}</i-option>
        </i-select>
      </div>
      <div class="mr">
        <span>选择实验：</span>
        <i-select v-model="pageData.ExpID" style="width:200px">
          <i-option
            v-for="item in ExperimentList"
            :value="item.ExpID"
            :key="item.ExpID"
          >{{ item.ExpName }}</i-option>
        </i-select>
      </div>
      <div>
        <Button
          type="primary"
          class="mr"
          icon="md-search"
          @click="searchById(pageData.ClassId,pageData.ExpID)"
        >查询</Button>
        <Button type="primary" icon="md-refresh" @click="searchRefersh">重置</Button>
      </div>
    </div>
    <!-- {{ishasAllData}} -->
    <div v-if="ishasAllData">
      <!-- 进度条 -->
      <div class="progressDiv bg-div">
        <div class="progressTitle">本班学习进度</div>
        <div class="progressBox">
          <Progress :percent="scoreObj.Progress>100?100:scoreObj.Progress" :stroke-width="20"/>
        </div>
      </div>
      <Row :gutter="16" type="flex">
        <i-col :xs="24" :sm="24" :md="24" :lg="8">
          <div class="result" id="result" ref="result">
            <div class="resultTitle">本班各分数段人次</div>
            <div class="resultInfo">
              <ve-histogram
                :grid="{left:16,right:16}"
                :judge-width="true"
                :data="chartData"
                :settings="chartSettings"
                :extend="chartExtend"
                :data-empty="dataEmpty"
              ></ve-histogram>
            </div>
          </div>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="8">
          <div class="result">
            <div class="resultTitle">错误步骤（前十）</div>
            <div class="resultInfo">
              <Table size="small" :columns="columns" :data="scoreObj.StateTop"></Table>
            </div>
          </div>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="8">
          <div class="result">
            <div class="resultTitle">错误步骤（后十）</div>
            <div class="resultInfo">
              <Table size="small" :columns="columns" :data="scoreObj.StateBot"></Table>
            </div>
          </div>
        </i-col>
      </Row>
      <div class="bg-div">
        <Table :columns="columnsStu" :data="stuListObj.Result"></Table>
        <div class="page-div">
          <Page
            show-total
            :total="stuListObj.records"
            :current="pageData.page"
            :page-size="pageData.size"
            @on-change="changePage"
          />
        </div>
      </div>
    </div>
    <div v-else class="nodata" style="background:#fff;">当前账号下无实验</div>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import VeHistogram from "v-charts/lib/histogram.common.js";

export default {
  name: "resultsStatistical",
  components: {
    VeHistogram
  },
  data() {
    this.chartSettings = {
      yAxisName: ["次数"],
      labelMap: {
        Count: ""
      }
    };
    this.chartExtend = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return params[0].axisValue + "：<br/>" + params[0].data + "人";
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    return {
      loading: true,
      pageData: {
        ClassId: 0,
        ExpID: 0,
        page: 1,
        size: 10
      },
      ClassArr: [],
      ExperimentList: [],
      scoreObj: {},
      stuListObj: { Result: [] },
      columns: [
        //错误步骤
        {
          title: "步骤",
          key: "ExpStepName",
          tooltip: true
        },
        {
          title: "次数",
          key: "Count",
          width: 64,
          align: "center"
        }
      ],
      columnsStu: [
        {
          title: "学号",
          key: "SId",
          tooltip: true,
          align: "center"
        },
        {
          title: "班级",
          key: "ClassName",
          tooltip: true,
          align: "center"
        },
        {
          title: "学生姓名",
          key: "UserName",
          tooltip: true,
          align: "center"
        },
        {
          title: "开始时间",
          key: "StartTime",
          tooltip: true,
          align: "center"
        },
        {
          title: "结束时间",
          key: "EndTime",
          tooltip: true,
          align: "center"
        },
        {
          title: "分数",
          key: "Score",
          tooltip: true,
          align: "center"
        },
        {
          title: "操作时长",
          key: "TimeLength",
          tooltip: true,
          align: "center"
        }
      ],
      hasAllData: false,
      chartData: {}, //本班各分数段人次
      dataEmpty: true
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    },
    ishasAllData() {
      if (this.ClassArr.length > 0 && this.ExperimentList.length > 0) {
        this.hasAllData = true;
        return true;
      } else {
        this.hasAllData = false;
        return false;
      }
    }
  },
  watch: {
    hasAllData(val) {
      if (val) {
        this.searchById(this.ClassArr[0].ClassId, this.ExperimentList[0].ExpID);
      }
    }
  },
  mounted() {
    this.GetTchClass();
    this.GetExperimentList();
  },
  methods: {
    async GetTchClass() {
      this.ClassArr = await homeApi.GetTchClass();
    },
    // 获取所有实验
    async GetExperimentList() {
      this.ExperimentList = await homeApi.GetExperimentList({
        Search: ""
      });
    },
    // 获取成绩统计信息
    async getpageArr() {
      homeApi
        .GetScore({
          ClassId: this.pageData.ClassId
            ? this.pageData.ClassId
            : this.ClassArr[0].ClassId,
          ExpID: this.pageData.ExpID
            ? this.pageData.ExpID
            : this.ExperimentList[0].ExpID
        })
        .then(res => {
          this.scoreObj = res;
          if (res.scores) {
            if (res.scores.length > 0) {
              this.chartData = {
                columns: ["Score", "Count"],
                rows: res.scores
              };
              this.dataEmpty = false;
            } else {
              this.chartData = {
                columns: ["Score", "Count"],
                rows: []
              };
              this.dataEmpty = true;
            }
          } else {
             this.chartData = {
                columns: ["Score", "Count"],
                rows: []
              };
              this.dataEmpty = true;
          }
        });
    },
    // 获取实验学生列表
    async GetStuList() {
      this.stuListObj = await homeApi.GetStuList({
        ClassId: this.pageData.ClassId
          ? this.pageData.ClassId
          : this.ClassArr[0].ClassId,
        ExpID: this.pageData.ExpID
          ? this.pageData.ExpID
          : this.ExperimentList[0].ExpID,
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });
      this.loading = false;
    },
    //搜索
    searchById(ClassId, ExpID) {
      this.pageData.ClassId = ClassId;
      this.pageData.ExpID = ExpID;
      this.pageData.page = 1;
      this.getpageArr();
      this.GetStuList();
    },
    // 重置
    searchRefersh() {
      if (this.hasAllData) {
        this.pageData.ClassId = this.ClassArr[0].ClassId;
        this.pageData.ExpID = this.ExperimentList[0].ExpID;
        this.pageData.page = 1;
        this.getpageArr();
        this.GetStuList();
      }
    },
    changePage(page) {
      this.pageData.page = page;
      this.GetStuList();
    }
  }
};
</script>

<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>